const doc = [({"en":({"js":({"admin":({"contacts":({"edit":({"historical_data_card":({"historical_data":"Historical data"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;